export const VENDA_ETAPAS = [
  { value: 'fazendo_contato', label: 'Fazendo contato', description: 'Primeiro contato e abertura de relacionamento' },
  { value: 'encaminhando_venda', label: 'Encaminhando para venda', description: 'Entendimento inicial de demandas e briefing' },
  { value: 'venda', label: 'Venda', description: 'Apresentação de proposta e construção de valor' },
  { value: 'follow_up', label: 'Follow-up', description: 'Acompanhamento ativo e alinhamentos' },
  { value: 'fechamento', label: 'Fechamento', description: 'Negociação final e superação de objeções' },
  { value: 'negocio_fechado', label: 'Negócio fechado', description: 'Contrato fechado e aceite do cliente' },
] as const;

export type VendaEtapa = (typeof VENDA_ETAPAS)[number]['value'];

export interface VendaSessao {
  id: string;
  empresa_id: string;
  criado_por: string;
  responsavel_id: string;
  cliente_nome: string;
  oportunidade: string | null;
  observacoes: string | null;
  etapa: VendaEtapa;
  status: 'ativa' | 'pausada' | 'encerrada';
  resumo_contexto: string;
  duracao_segundos: number;
  ultima_interacao_em: string;
  created_at: string;
  updated_at: string;
}

export interface VendaTrecho {
  id: string;
  sessao_id: string;
  empresa_id: string;
  enviado_por: string;
  origem: 'texto' | 'audio';
  conteudo: string;
  duracao_segundos?: number | null;
  status: 'processando' | 'concluido' | 'erro';
  erro?: string | null;
  created_at: string;
}

export type TipoAnaliseIa = 'rapport' | 'tecnicas' | 'cliente' | 'proposta' | 'velocimetro';

export interface CardDiagnostico {
  key: string;
  titulo: string;
  conteudo: string;
  destaque?: string;
  alerta?: boolean;
}

export interface VendaAnalise {
  id: string;
  sessao_id: string;
  trecho_id: string;
  empresa_id: string;
  tipo: TipoAnaliseIa;
  titulo: string;
  resumo: string;
  dados: {
    cards?: CardDiagnostico[];
    [key: string]: unknown;
  };
  sugestao_fala: string | null;
  score: number | null;
  created_at: string;
}

export interface VendaUsoIa {
  id: string;
  sessao_id: string;
  trecho_id: string | null;
  empresa_id: string;
  user_id: string;
  tipo: TipoAnaliseIa | 'transcricao';
  provider: string;
  model: string;
  input_tokens: number;
  output_tokens: number;
  cost_usd: number;
  duracao_ms: number | null;
  minutos_audio: number | null;
  run_id: string | null;
  created_at: string;
}

export const DIAGNOSTICO_CARDS = [
  { key: 'rapport', domain: 'rapport', label: '1. Rapport e Confiança' },
  { key: 'escuta', domain: 'rapport', label: '7. Escuta e Condução' },
  { key: 'tecnicas', domain: 'tecnicas', label: '2. 13 Técnicas de Vendas' },
  { key: 'perguntas', domain: 'tecnicas', label: '6. Perguntas Sugeridas' },
  { key: 'objecoes', domain: 'tecnicas', label: '8. Objeções & Quebra de Objeção' },
  { key: 'cliente', domain: 'cliente', label: '3. Informações do Cliente' },
  { key: 'qualificacao', domain: 'cliente', label: '4. Qualificação & ICP' },
  { key: 'decisores', domain: 'cliente', label: '5. Decisores e Processo de Compra' },
  { key: 'valor', domain: 'proposta', label: '9. Valor e Impacto' },
  { key: 'proposta', domain: 'proposta', label: '10. Proposta Comercial' },
  { key: 'negociacao', domain: 'proposta', label: '11. Negociação e Margem' },
  { key: 'proximo_passo', domain: 'proposta', label: '12. Próximo Passo' },
  { key: 'follow_up', domain: 'proposta', label: '13. Follow-up Indicado' },
  { key: 'velocimetro', domain: 'velocimetro', label: '14. Velocímetro da Venda' },
] as const;

export const DOMAIN_LABELS: Record<TipoAnaliseIa, string> = {
  rapport: 'Rapport, Confiança e Condução',
  tecnicas: 'Técnicas, Perguntas & Objeções',
  cliente: 'Inteligência do Cliente & Decisores',
  proposta: 'Proposta, Negociação & Próximos Passos',
  velocimetro: 'Velocímetro da Venda (Nota 0 a 100)',
};